/**
 * ��������� �������� ������� ����� ������ �������� DOM.
 * @param {Function} callback - �������, ������� ���������� ��������� ����� �������� DOM.
 */
export default function onDomReady(callback) {
    // ���������, ��������� �� DOM � ��������� ��������
    if (document.readyState === 'loading') {
        // ���� DOM ��� ��� �����������, ��������� ��������� ������� DOMContentLoaded
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        // ���� DOM ��� ��������, �������� ������� ��������� ������ ����������
        callback();
    }    
}
